var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27011",
    "data-name": "Group 27011",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27010",
    "data-name": "Group 27010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10611",
    "data-name": "Path 10611",
    d: "M10.23,15.83a1,1,0,0,0,1.41,0l4.24-4.24a1.008,1.008,0,0,0,0-1.42h0a1,1,0,0,0-1.41,0L10.93,13.7,9.52,12.29a1.008,1.008,0,0,0-1.42,0,.987.987,0,0,0,0,1.41Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M19,4H5A2,2,0,0,0,3,6V18a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,13a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V8H19Z",
    fill: "#f0f0f0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.ca2e75868d853c75a6ff5665108e3118.svg";
export { ForwardRef as ReactComponent };